import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../list/actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import store from '../../../../store';

function* archiveAssignment({ payload: { id, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.archive, id });

    dispatch(listActions.getAssignmentsRequest({ status: 'published', curr_page: getState().getAssignments.curr_page }));

    onSuccess && onSuccess();
    yield put(actions.archiveAssignmentDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.archiveAssignmentFailed,
      endpoint: api.modifiers.assignments.archive.url
    });
  }
}

export const archiveAssignmentSaga = takeEvery(types.ARCHIVE_ASSIGNMENT_REQUEST, archiveAssignment);